import Vue from "vue";
import isNil from "lodash/isNil";
import jwt from "jsonwebtoken";

// import formDatas from '../../lib/formDatas'
// import router from '../../router'

export default {
  state: {
    user: {},
  },
  getters: {
    isUser: (state) => Boolean(state?.user?.user_no),
    isClient: (state) => Boolean(state?.user?.cust_no),
    isDealer: (state) => Boolean(state?.user?.dealer_no),
    isSocial: (state) => Boolean(state?.user?.user_social_provider !== "local"),
    hasNeededInfo: (state) => {
      // 필수정보 입력 여부
      if (!state?.user?.user_no) {
        return false;
      }

      const isClient = Boolean(state?.user?.cust_no);
      const isDealer = Boolean(state?.user?.dealer_no);

      if (isClient) {
        if (
          // 필수정보 체크
          !state.user.user_contact
        ) {
          return false;
        }

        return true;
      }

      if (isDealer) {
        if (
          // 필수정보 체크
          (!state.user.user_contact,
          !state.user.dealer_type,
          !state.user.dealer_name)
        ) {
          return false;
        }

        return true;
      }

      throw new Error("user_type이 없는 사용자입니다.");
    },
    isVerified: (state) => {
      // 심사완료 여부
      if (!state?.user?.user_no) {
        return false;
      }

      const isClient = Boolean(state?.user?.cust_no);
      const isDealer = Boolean(state?.user?.dealer_no);

      if (isClient) {
        return true;
      }

      if (isDealer) {
        return state?.user?.state === 1;
      }

      throw new Error("user_type이 없는 사용자입니다.");
    },
    user: (state) => state.user,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setReport(state, payload) {
      state.report = payload;
    },
  },
  actions: {
    async userLogin({ state, commit, dispatch }, payload) {
      const tokenName = process.env.VUE_APP_TOKEN_NAME;
      let decodedJWT;

      try {
        if (payload?.user_type === "client") {
          const {
            data: { token },
          } = await Vue.axios.post("/api/user/v1/auth/login", payload);
          if (token) {
            localStorage.setItem(tokenName, token);
            decodedJWT = jwt.decode(token);
            await dispatch("userDetail", { user_type: decodedJWT.user_type });
          }
        }

        if (payload?.user_type === "dealer") {
          const {
            data: { token },
          } = await Vue.axios.post("/api/dealer/v1/auth/login", payload);
          if (token) {
            localStorage.setItem(tokenName, token);
            decodedJWT = jwt.decode(token);
            await dispatch("userDetail", { user_type: decodedJWT.user_type });
          }
        }

        // Return the decoded JWT or relevant part of it
        return decodedJWT;
      } catch (e) {
        localStorage.removeItem(tokenName);
        throw e;
      }
    },
    async userDetail({ state, commit, dispatch }, payload) {
      let user_type = null;

      if (!payload) {
        const isDealer = Boolean(state?.user?.dealer_no);
        const isClient = Boolean(state?.user?.cust_no);

        if (isDealer) {
          user_type = "dealer";
        }

        if (isClient) {
          user_type = "client";
        }
      } else {
        user_type = payload.user_type;
      }

      if (user_type === "client") {
        const data = await Vue.axios
          .get("/api/user/v1/auth/profile")
          .then((response) => response.data.query);

        if (!data) {
          window.localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
          window.location.reload();
          return;
        }
        commit("setUser", data);
        return;
      }

      if (user_type === "dealer") {
        const data = await Vue.axios
          .get("/api/dealer/v1/auth/profile")
          .then((response) => response.data.query);

        if (!data) {
          window.localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
          window.location.reload();
          return;
        }
        commit("setUser", data);
        return;
      }

      throw new Error("인증 토큰에 user_type이 없습니다.");
    },
    async userDetailUpdate({ state, commit, dispatch }, payload) {
      const isClient = Boolean(state?.user?.cust_no);
      const isDealer = Boolean(state?.user?.dealer_no);

      if (isClient) {
        const formData = new FormData();

        for (const [key, value] of Object.entries(payload)) {
          if (
            Object(value) === value &&
            !(value instanceof File) &&
            !(value instanceof Blob)
          ) {
            formData.append(key, JSON.stringify(value));
          } else if (!isNil(value)) {
            formData.append(key, value);
          }
        }

        await Vue.axios
          .post("/api/user/v1/auth/profile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => response.data.query);

        await dispatch("userDetail", { user_type: "client" });
      }

      if (isDealer) {
        const formData = new FormData();

        for (const [key, value] of Object.entries(payload)) {
          if (
            Object(value) === value &&
            !(value instanceof File) &&
            !(value instanceof Blob)
          ) {
            formData.append(key, JSON.stringify(value));
          } else if (!isNil(value)) {
            formData.append(key, value);
          }
        }

        await Vue.axios
          .post("/api/dealer/v1/auth/profile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => response.data.query);

        await dispatch("userDetail", { user_type: "dealer" });
      }
    },
    async userLogout({ state, commit, dispatch }) {
      const provider = state.user.user_social_provider;
      const isClient = Boolean(state?.user?.cust_no);
      const isDealer = Boolean(state?.user?.dealer_no);

      // 카카오 로그아웃
      if (provider === "kakao") {
        if (isClient) {
          const data = await Vue.axios
            .get("/api/user/v1/auth/logout/kakao")
            .then((response) => response.data);

          window.location.replace("/");
        }

        if (isDealer) {
          const data = await Vue.axios
            .get("/api/dealer/v1/auth/logout/kakao")
            .then((response) => response.data);

          window.location.href = data.redirect;
        }
      }

      localStorage.clear();

      window.location.replace("/");
    },
  },
};
